/**
 * Ray-casting point-in-polygon test.
 * Returns true if (px, py) is inside the polygon defined by the given vertices.
 */
export function pointInPolygon(px, py, polygon) {
    let inside = false;
    for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
        const pi = polygon[i];
        const pj = polygon[j];
        if (pi.y > py !== pj.y > py &&
            px < ((pj.x - pi.x) * (py - pi.y)) / (pj.y - pi.y) + pi.x) {
            inside = !inside;
        }
    }
    return inside;
}
/**
 * Find the topmost (last-drawn) detection at the given canvas coordinates.
 * Checks polygon containment first (for segmentation masks), then falls
 * back to bounding-box.
 */
export function findDetectionAt(cx, cy, detections) {
    for (const det of [...detections].reverse()) {
        if (det.points && det.points.length > 2) {
            if (pointInPolygon(cx, cy, det.points))
                return det;
        }
        const left = det.x - det.width / 2;
        const top = det.y - det.height / 2;
        if (cx >= left &&
            cx <= left + det.width &&
            cy >= top &&
            cy <= top + det.height) {
            return det;
        }
    }
    return null;
}
